// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"1391931c","977":"2bb3933e"}[chunkId] + ".chunk.js";
};